import {
    TAB_CREATE,
    TAB_LIST,
    TAB_UPDATE
} from "../actions";

export function tab(currentState = {}, action) {
    switch (action.type) {
        case TAB_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case TAB_LIST:
            return currentState = action
        case TAB_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}